webpackJsonp([2],{

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentErrorPage_vue__ = __webpack_require__(314);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783d35c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentErrorPage_vue__ = __webpack_require__(393);
function injectStyle (ssrContext) {
  __webpack_require__(391)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentErrorPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_783d35c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentErrorPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MessageInfoAnimatedIconForStatus__ = __webpack_require__(293);
/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-27, 10:14:18
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-27, 10:19:47
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MessageInfo',

  components: { MessageInfoAnimatedIconForStatus: __WEBPACK_IMPORTED_MODULE_0__MessageInfoAnimatedIconForStatus__["a" /* default */] },

  props: {
    messageType: {
      type: String,
      default: 'success'
    },
    title: {
      type: String,
      default: 'Title'
    },
    code: {
      type: String,
      default: '200'
    },
    description: {
      type: String,
      default: 'Description'
    }
  },

  computed: {
    codeColor: function codeColor() {
      return {
        success: 'color: #33691e',
        error: 'color: #c62828'
      }[this.messageType];
    }
  }
});

/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b1d3d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(297);
function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var normalizeComponent = __webpack_require__(19)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b1d3d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_component_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b1d3d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(292);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(275)("7981dd8e", content, true, {});

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(274)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-64b1d3d4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-64b1d3d4{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.MessageInfo[data-v-64b1d3d4]{margin-top:80px;border:0;background:none;min-height:500px}@media screen and (max-width:768px){.MessageInfo[data-v-64b1d3d4]{margin-top:5px}}.MessageInfo__content[data-v-64b1d3d4]{color:#4e4a4a}.MessageInfo__content .content__message[data-v-64b1d3d4]{display:block;font-size:20px;text-align:center;margin:2px}.MessageInfo__content .content__code[data-v-64b1d3d4]{display:block;font-size:140px;font-weight:900;text-align:center;margin:0}@media screen and (max-width:768px){.MessageInfo__content .content__code[data-v-64b1d3d4]{font-size:80px}}.MessageInfo__description[data-v-64b1d3d4]{text-align:center;margin:15px 0;color:#4e4a4a}.MessageInfo__footer[data-v-64b1d3d4]{margin:15px}", "", {"version":3,"sources":["/builds/Telestrada/payments.telestrada-online.pl/platform/src/components/Common/MessageInfo/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,8BACE,gBAAiB,AACjB,SAAY,AACZ,gBAAiB,AACjB,gBAAkB,CACnB,AACD,oCACA,8BACM,cAAgB,CACrB,CACA,AACD,uCACI,aAAe,CAClB,AACD,yDACM,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,UAAY,CACjB,AACD,sDACM,cAAe,AACf,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,QAAY,CACjB,AACD,oCACA,sDACU,cAAgB,CACzB,CACA,AACD,2CACI,kBAAmB,AACnB,cAAe,AACf,aAAe,CAClB,AACD,sCACI,WAAa,CAChB","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-64b1d3d4 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-64b1d3d4 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.MessageInfo[data-v-64b1d3d4] {\n  margin-top: 80px;\n  border: 0px;\n  background: none;\n  min-height: 500px;\n}\n@media screen and (max-width: 768px) {\n.MessageInfo[data-v-64b1d3d4] {\n      margin-top: 5px;\n}\n}\n.MessageInfo__content[data-v-64b1d3d4] {\n    color: #4E4A4A;\n}\n.MessageInfo__content .content__message[data-v-64b1d3d4] {\n      display: block;\n      font-size: 20px;\n      text-align: center;\n      margin: 2px;\n}\n.MessageInfo__content .content__code[data-v-64b1d3d4] {\n      display: block;\n      font-size: 140px;\n      font-weight: 900;\n      text-align: center;\n      margin: 0px;\n}\n@media screen and (max-width: 768px) {\n.MessageInfo__content .content__code[data-v-64b1d3d4] {\n          font-size: 80px;\n}\n}\n.MessageInfo__description[data-v-64b1d3d4] {\n    text-align: center;\n    margin: 15px 0;\n    color: #4E4A4A;\n}\n.MessageInfo__footer[data-v-64b1d3d4] {\n    margin: 15px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26691738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(296);
function injectStyle (ssrContext) {
  __webpack_require__(294)
}
var normalizeComponent = __webpack_require__(19)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = true
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26691738"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26691738_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_stripWithFunctional_true_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(295);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(275)("fb5b9240", content, true, {});

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(274)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner-data-v-26691738{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner-data-v-26691738{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}svg[data-v-26691738]{width:190px;display:block;margin:0 auto}@media screen and (max-width:768px){svg[data-v-26691738]{width:60px}}.path[data-v-26691738]{stroke-dasharray:1000;stroke-dashoffset:0}.path.circle[data-v-26691738]{-webkit-animation:dash-data-v-26691738 .9s ease-in-out;animation:dash-data-v-26691738 .9s ease-in-out}.path.line[data-v-26691738]{stroke-dashoffset:1000;-webkit-animation:dash-data-v-26691738 .9s .35s ease-in-out forwards;animation:dash-data-v-26691738 .9s .35s ease-in-out forwards}.path.check[data-v-26691738]{stroke-dashoffset:-100;-webkit-animation:dash-check-data-v-26691738 .9s .35s ease-in-out forwards;animation:dash-check-data-v-26691738 .9s .35s ease-in-out forwards}@-webkit-keyframes dash-data-v-26691738{0%{stroke-dashoffset:1000}to{stroke-dashoffset:0}}@keyframes dash-data-v-26691738{0%{stroke-dashoffset:1000}to{stroke-dashoffset:0}}@-webkit-keyframes dash-check-data-v-26691738{0%{stroke-dashoffset:-100}to{stroke-dashoffset:900}}@keyframes dash-check-data-v-26691738{0%{stroke-dashoffset:-100}to{stroke-dashoffset:900}}", "", {"version":3,"sources":["/builds/Telestrada/payments.telestrada-online.pl/platform/src/components/Common/MessageInfo/MessageInfoAnimatedIconForStatus/style.sass"],"names":[],"mappings":"AACA,2CACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mCACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,qBACE,YAAa,AACb,cAAe,AACf,aAAmB,CACpB,AACD,oCACA,qBACM,UAAY,CACjB,CACA,AACD,uBACE,sBAAuB,AACvB,mBAAqB,CACtB,AACD,8BACI,uDAAwD,AACxD,8CAAgD,CACnD,AACD,4BACI,uBAAwB,AACxB,qEAAsE,AACtE,4DAA8D,CACjE,AACD,6BACI,uBAAwB,AACxB,2EAA4E,AAC5E,kEAAoE,CACvE,AACD,wCACA,GACI,sBAAwB,CAC3B,AACD,GACI,mBAAqB,CACxB,CACA,AACD,gCACA,GACI,sBAAwB,CAC3B,AACD,GACI,mBAAqB,CACxB,CACA,AACD,8CACA,GACI,sBAAwB,CAC3B,AACD,GACI,qBAAuB,CAC1B,CACA,AACD,sCACA,GACI,sBAAwB,CAC3B,AACD,GACI,qBAAuB,CAC1B,CACA","file":"style.sass","sourcesContent":["\n@-webkit-keyframes spinner-data-v-26691738 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner-data-v-26691738 {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\nsvg[data-v-26691738] {\n  width: 190px;\n  display: block;\n  margin: 0px auto 0;\n}\n@media screen and (max-width: 768px) {\nsvg[data-v-26691738] {\n      width: 60px;\n}\n}\n.path[data-v-26691738] {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 0;\n}\n.path.circle[data-v-26691738] {\n    -webkit-animation: dash-data-v-26691738 .9s ease-in-out;\n    animation: dash-data-v-26691738 .9s ease-in-out;\n}\n.path.line[data-v-26691738] {\n    stroke-dashoffset: 1000;\n    -webkit-animation: dash-data-v-26691738 .9s .35s ease-in-out forwards;\n    animation: dash-data-v-26691738 .9s .35s ease-in-out forwards;\n}\n.path.check[data-v-26691738] {\n    stroke-dashoffset: -100;\n    -webkit-animation: dash-check-data-v-26691738 .9s .35s ease-in-out forwards;\n    animation: dash-check-data-v-26691738 .9s .35s ease-in-out forwards;\n}\n@-webkit-keyframes dash-data-v-26691738 {\n0% {\n    stroke-dashoffset: 1000;\n}\n100% {\n    stroke-dashoffset: 0;\n}\n}\n@keyframes dash-data-v-26691738 {\n0% {\n    stroke-dashoffset: 1000;\n}\n100% {\n    stroke-dashoffset: 0;\n}\n}\n@-webkit-keyframes dash-check-data-v-26691738 {\n0% {\n    stroke-dashoffset: -100;\n}\n100% {\n    stroke-dashoffset: 900;\n}\n}\n@keyframes dash-check-data-v-26691738 {\n0% {\n    stroke-dashoffset: -100;\n}\n100% {\n    stroke-dashoffset: 900;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"MessageInfoAnimatedIconForStatus"},[(_vm.props.type === 'success')?_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 130.2 130.2"}},[_c('circle',{staticClass:"path circle",attrs:{"fill":"none","stroke":"#33691e","stroke-width":"6","stroke-miterlimit":"10","cx":"65.1","cy":"65.1","r":"62.1"}}),_vm._v(" "),_c('polyline',{staticClass:"path check",attrs:{"fill":"none","stroke":"#33691e","stroke-width":"6","stroke-linecap":"round","stroke-miterlimit":"10","points":"100.2,40.2 51.5,88.8 29.8,67.5 "}})]):_vm._e(),_vm._v(" "),(_vm.props.type === 'error')?_c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200.2 200.2"}},[_c('circle',{staticClass:"path circle",attrs:{"fill":"none","stroke":"#c62828","stroke-width":"15","stroke-miterlimit":"10","cx":"100.1","cy":"100.1","r":"90.1"}}),_vm._v(" "),_c('line',{staticClass:"path line",attrs:{"fill":"none","stroke":"#c62828","stroke-width":"15","stroke-linecap":"round","stroke-miterlimit":"10","x1":"54.4","y1":"57.9","x2":"145.8","y2":"142.3"}}),_vm._v(" "),_c('line',{staticClass:"path line",attrs:{"fill":"none","stroke":"#c62828","stroke-width":"15","stroke-linecap":"round","stroke-miterlimit":"10","x1":"145.8","y1":"57.9","x2":"54.4","y2":"142.3"}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"MessageInfo",attrs:{"body-style":{ padding: '0px' },"shadow":"never"}},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":8}},[_c('MessageInfoAnimatedIconForStatus',{attrs:{"type":_vm.messageType}})],1),_vm._v(" "),_c('el-col',{staticClass:"MessageInfo__content",attrs:{"xs":24,"sm":16}},[_c('label',{staticClass:"content__message"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('label',{staticClass:"content__code",style:(_vm.codeColor)},[_vm._v(_vm._s(_vm.code))])]),_vm._v(" "),_c('el-col',{staticClass:"MessageInfo__description",attrs:{"xs":24,"sm":24}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})])],1),_vm._v(" "),_c('div',{staticClass:"MessageInfo__footer"},[_vm._t("footer")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Common_MessageInfo__ = __webpack_require__(290);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentPageError',
  components: { MessageInfo: __WEBPACK_IMPORTED_MODULE_1__components_Common_MessageInfo__["a" /* default */] },
  store: __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */],
  computed: {
    errorMessage: function errorMessage() {
      return {
        type: 'error',
        title: this.$t('wrong_or_expired_token_page.title'),
        code: this.$t('wrong_or_expired_token_page.code'),
        description: this.$t('wrong_or_expired_token_page.description')
      };
    }
  }
});

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(392);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(275)("250cc10e", content, true, {});

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(274)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes spinner{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.PaymentPageErrorView{margin-top:10px}", "", {"version":3,"sources":["/builds/Telestrada/payments.telestrada-online.pl/platform/src/views/PaymentErrorPage.vue"],"names":[],"mappings":"AACA,2BACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,mBACA,GACI,gCAAkC,AAC1B,uBAA0B,CACrC,CACA,AACD,sBACE,eAAiB,CAClB","file":"PaymentErrorPage.vue","sourcesContent":["\n@-webkit-keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes spinner {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.PaymentPageErrorView {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PaymentPageErrorView"},[_c('el-row',{attrs:{"justify":'center',"align":'middle',"type":"flex"}},[_c('el-col',{attrs:{"sm":13}},[_c('MessageInfo',{attrs:{"messageType":_vm.errorMessage.type,"title":_vm.errorMessage.title,"code":_vm.errorMessage.code,"description":_vm.errorMessage.description}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.38121e0cc360fd51620e.js